import trucksDatabase from './trucks.database'
import pautasDatabase from './pautas.database'
import sitesDatabase from './sites.database'
import FilesToStringDatabase from './3dFilesToString.database'
import machinesDatabase from './machines.database'
import machinesImagesDatabase from './machinesImages.database'
import reportsDatabase from './reports.database'
import activitiesDatabase from './activities.database'
import executionReportsDatabase from './executionReports.database'
import machinesPartsDatabase from './machinesParts.database'
import imageDatabase from './image.database'
import userDatabase from './user.database'
import readyToSendReportsDatabase from './readyToSendReports.database'
import dispositivosDatabase from './dispositivos.database'
import logsDatabase from './logs.database'

import pmsDatabase from './pms.database'
import { GenericDatabase } from './GenericDatabase'
import documentationDatabase from './documentation.database'

// Re-export with original names for backward compatibility
const headerPautasDatabase = {
    initDbPMs: pmsDatabase.initDb,
    agregar: pmsDatabase.agregarHeader,
    obtener: pmsDatabase.obtenerHeader,
    actualizar: pmsDatabase.actualizarHeader,
    eliminar: pmsDatabase.eliminarHeader,
    consultar: pmsDatabase.consultarHeaders
}

const structPautasDatabase = {
    initDbPMs: pmsDatabase.initDb,
    agregar: pmsDatabase.agregarStruct,
    obtener: pmsDatabase.obtenerStruct,
    actualizar: pmsDatabase.actualizarStruct,
    eliminar: pmsDatabase.eliminarStruct,
    consultar: pmsDatabase.consultarStructs
}
export const clearAllDatabases = async () => {
    try {
        GenericDatabase.closeAll()
    } catch (e) {
        console.error('Error closing database connections before delete:', e)
    }

    const dbs = [
        'Documentation',
        'TechnicalDocumentation',
        'Executions',
        'Pautas',
        'User',
        'Sites',
        'Machines',
        'Images',
        'Logs',
        '3Ds',
        'Activities',
        'Device',
        'MachinesImages',
        'MachinesParts',
        'PMs',
        'ReportesListos',
        'Trucks'
    ]
    const promises = dbs.map((name) => {
        return new Promise((resolve, reject) => {
            const req = window.indexedDB.deleteDatabase(name)
            req.onsuccess = () => {
                console.log(`Database ${name} deleted successfully`)
                resolve()
            }
            req.onerror = () => {
                console.warn(`Error deleting database ${name}`)
                resolve() // Resolve anyway to continue
            }
            req.onblocked = () => {
                console.warn(`Deletion of database ${name} blocked`)
                resolve()
            }
        })
    })
    await Promise.all(promises)
}

export {
    trucksDatabase,
    pautasDatabase,
    headerPautasDatabase,
    structPautasDatabase,
    sitesDatabase,
    FilesToStringDatabase,
    machinesDatabase,
    machinesImagesDatabase,
    reportsDatabase,
    activitiesDatabase,
    executionReportsDatabase,
    machinesPartsDatabase,
    imageDatabase,
    readyToSendReportsDatabase,
    userDatabase,
    dispositivosDatabase,
    logsDatabase,
    documentationDatabase
}
